/**
 * 商品结算
 * 通过物流接口获取运费，进行价格统计
 */
import * as React from 'react';
import doLog from '../../../common/log';
import * as cookieInfo from '@alife/bc-cookie-info';
import InqueryPrice from './inquery-price';
import TotalPrice from './total-price';
import ShippingPrice from './shipping-price';
import MoqPrice from './moq-price';
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { setLeadTime, setTotalPrice, setAddCart } from '../../../redux/reduces/skuSlice'

const { useMemo, useState } = React;

interface ExpressProps {
  method?: string
  displayOriginalCost?: string
  time?: string
  leadTime?: string
  freightGuaranteeResultDTO?: string
  contractSolutionDetailDTO?: {
    carrierCode: string
  }
  originalCost?: number
  isEmpty: boolean
}

export default function SampleExpress(props: any) {
  const {
    productId,
    price,
    moq = 1,
    i18n,
    type,
    dispatchId,
    country,
    children,
  } = props;

  const dispatch = useAppDispatch();

  // 获取sku信息
  const skuInfo = useAppSelector(state => state.sku[type])
  const {price: productPrice } = skuInfo;

  const selectSkuInfo = Object.values(skuInfo.map).filter((i:any) => i.number > 0);
  const quantity: any = selectSkuInfo.reduce((a: any, {number = 0}: any) => a + number, 0);
  // 总价计算包含
  const totalPrice: any = selectSkuInfo.reduce((a: number, {number = 0, price = 0, promotionPrice = 0}) => a + (promotionPrice || price || productPrice) * number, 0);
  
   // 更新总价格    
   dispatch(setTotalPrice({
    type,
    quantity,
    totalPrice,
  }));

  const [expressData, setData] = useState<ExpressProps>({
    isEmpty: true
  });

  // 物流请求参数
  const params: any = {
    pid: productId,
    quantity: quantity || moq,
    terminal: "PC",
    country,
    calculateScene: type === 'sample' ? "SAMPLE_DETAIL" : '',
    dispatchLocation: dispatchId,
    // 更新总价格
    productTotalPrice: quantity > 0 ? totalPrice : productPrice,
    // 更新sku选择
    skuQuantity:
      quantity > 0 ?
        selectSkuInfo.reduce((obj: any, cur: { skuId: any; number: any; }) => ({ ...obj, [cur.skuId]: cur.number }), {}) :
        {},
    locale: cookieInfo.getBuyerLocale(),
    currency: cookieInfo.getBuyerCurrency(),
    userCna: cookieInfo.getCNA()
  };

  // 获取物流
  const getExpress = async () => {
    if (expressData.method) {
      params.method = expressData.method
    }
    const result = await fetch(`//template.alibaba.com/freight/listFreightCostForDetail.jsonp?json=${JSON.stringify(params)}`)
      .then((response: { json: () => any; }) => response.json());
    if (result.data?.requestId) {
      doLog(
        '/sc.details.logisticsShow',
        `requestid=${result.data.requestId}`,
        'EXP'
      );
    }
    // 取第一个优惠价格
    if (result.data?.data?.length > 0) {
      const getExpress = result.data.data[0];

      if (quantity > 0 && expressData?.contractSolutionDetailDTO?.carrierCode !== getExpress?.contractSolutionDetailDTO?.carrierCode) {
        doLog(
          '/sc.details.logisticsSkuChange',
          `requestid=${result.data?.requestId}&code=${getExpress?.contractSolutionDetailDTO?.freightCarrierCode}`
        );
      }


      if (getExpress?.leadTime && type === 'goods') {
        dispatch(setLeadTime(getExpress.leadTime))
      }
      dispatch(setAddCart(true));
      setData({
        ...getExpress,
        isEmpty: false
      });
    } else {
      setData({
        isEmpty: true
      });
    }
  }

  const handleExpress = () => {
    doLog(
      '/sc.details.sampleExpress',
      `requestid=${productId}`,
      'CLK',
    );
    // 物流弹窗通过window绑定，因为包太大异步加载
    if (window.ExpressDialog) {
      window.ExpressDialog({
        ...params,
        productId,
        count: params.quantity,
        method: expressData.method,
        sku: JSON.stringify(params.skuQuantity),
        onConfirm: (responseData: any) => {
          if (expressData?.contractSolutionDetailDTO?.carrierCode !== responseData?.contractSolutionDetailDTO?.carrierCode) {
            doLog(
              '/sc.details.logisticsDialogChange',
              `requestid=${responseData?.requestId}&code=${responseData?.contractSolutionDetailDTO?.freightCarrierCode}`
            );
          }
          // 更新物流
          if (responseData) {
            setData({
              ...expressData,
              ...responseData,
            })
          }
        },
      });
    }
  }

  // 数量变化更新物流
  useMemo(() => {
    getExpress();
  }, [quantity]);

  // 更新价格
  const { displayOriginalCost, time, freightGuaranteeResultDTO, method, originalCost = 0, isEmpty = true } = expressData;
  

  // 由于后端[何文]和客户端[火人]特殊约定，样品单货币已经做了转换，无需本地货币换算
  const formatTotalPrice = () => {
    if (price?.currencyRule) {
        // 汇率换算
      const {
        currencyRule: {
          currencyPattern,
          maximumFractionDigits,
          rate,
      } } = price;
      if (type === "sample") {
        return currencyPattern.replace("{0}",(totalPrice + originalCost * rate).toFixed(maximumFractionDigits))
      }
      return currencyPattern.replace("{0}",((totalPrice + originalCost) * rate).toFixed(maximumFractionDigits))
    }
  }

  return (
    <div className="float-action-inner sample-express">
      {type === 'goods' ? <MoqPrice
        {...props}
        quantity={quantity}
      >
          <input type="hidden" name="dispatchLocation" value={dispatchId} />
          <input type="hidden" name="clickId" value={3330} />
          <input type="hidden" name="pageId" value={window.dmtrack_pageid} />
          <input type="hidden" name="country" value={country} />
          <input type="hidden" name="shippingCompany" value={method} />
          <input type="hidden" name="shippingMethod" value="express" />
          <input type="hidden" name="quantity" value={quantity} />
          <input type="hidden" name="productId" value={productId} />
          <input type="hidden" name="lang" value={cookieInfo.getBuyerLocale()} />
          <input type="hidden" name="data" value={JSON.stringify(selectSkuInfo.map((i:any) => ({
            productId,
            skuId: i.skuId,
            dispatchLocation: dispatchId,
            quantity: i.number,
            recommendStockCode: i.storeCode,
            inventoryId: i.id
          })))} />
        </MoqPrice> : <InqueryPrice {...props} trade={expressData} />}
      <ShippingPrice id="sample-express-select" logistics={{
        ...expressData,
        handleClick: handleExpress,
        cost: displayOriginalCost,
        isEmpty
      }} quantity={quantity} price={price} moq={moq} i18n={i18n}
      />
      <TotalPrice totalCost={(totalPrice || originalCost) ? formatTotalPrice() : null} i18n={i18n} quantity={quantity} moq={moq} logistics={{
          ...expressData,
          logisticsTime: time,
          freightGuaranteeResult: freightGuaranteeResultDTO || {}
        }} />

      {React.cloneElement(children, {isEmpty})}
    </div>
  )
}
